export const libraryInfo = {
  name: '@segment/analytics-react-native',
  version: '2.16.1',
};
